const FullDate = /** @type {const} */ ({
  type: 'string',
  format: 'date',
});

export default FullDate;
